import React, { useMemo } from "react";
import { asText } from "@prismicio/helpers";
import type { SliceComponentProps } from "@prismicio/react";
import type { PopularProductsSlice } from "prismicio-types";
import type { ProductsAndCustomerContext } from "@commercekit/api";
import PopularProductsCategoryPage from "./variations/PopularProductsCategoryPage";
import PopularProductsHomePage from "./variations/PopularProductsHomePage";
import WvPopularProductsBlogContentPage from "./variations/PopularProductsBlogContentPage";
import { typedBoolean } from "@commercekit/shared";

const PopularProducts = ({
  slice,
  context,
}: SliceComponentProps<PopularProductsSlice>) => {
  const sliceContext = context as ProductsAndCustomerContext;
  const products = useMemo(
    () =>
      slice.items
        .map((i) =>
          sliceContext?.products?.find(
            (product) => product.sku === asText(i.product_sku)
          )
        )
        .filter(typedBoolean),
    [sliceContext.products, slice.items]
  );
  switch (slice.variation) {
    case "categoryPage": {
      return (
        <PopularProductsCategoryPage
          slice={slice}
          products={products}
          customer={sliceContext.customer}
        />
      );
    }
    case "blogContentPage": {
      return (
        <WvPopularProductsBlogContentPage
          slice={slice}
          products={products}
          customer={sliceContext.customer}
        />
      );
    }
    case "homePage": {
      return (
        <PopularProductsHomePage
          slice={slice}
          products={products}
          customer={sliceContext.customer}
        />
      );
    }

    default:
      return <div className="hidden">PopularProducts</div>;
  }
};

export default PopularProducts;
